import isUndefined from "lodash/isUndefined";
import mapValues from "lodash/mapValues";
import omitBy from "lodash/omitBy";
import { ProjectsSlice } from "PFApp/booking/store";

export const markRowAndChildrenByEnabledFlag = (
  allBookingsModeRowsState: ProjectsSlice["allBookingsModeRowsState"],
  rowKey: string,
  enabled: boolean
) =>
  mapValues(allBookingsModeRowsState, (value, key) => {
    if (key === rowKey) {
      return enabled ? "all" : "off";
    } else if (key.includes(rowKey)) {
      return enabled ? "all" : "unset";
    }
    return value;
  });

export const resetRowAndChildrenAllBookingsModeState = (
  allBookingsModeRowsState: ProjectsSlice["allBookingsModeRowsState"],
  rowKey: string
) =>
  omitBy(
    mapValues(allBookingsModeRowsState, (value, key) => {
      if (key === rowKey) {
        return "unset";
      } else if (key.includes(rowKey)) {
        return undefined;
      }
      return value;
    }),
    isUndefined
  );

export const expandRowAndItsChildren = (
  expandedRowsState: Record<string, boolean | undefined>,
  rowKey: string
) => mapValues(expandedRowsState, (value, key) => (key.includes(rowKey) ? true : value));
